import { Status } from '~/common/types';

export const ERROR_THRESHOLD = 0.5;
export const SUCCESS_THRESHOLD = 0.75;

export const getStatus = (changeRate: number, reverse?: boolean) => {
  let status = Status.NEUTRAL;

  if (reverse) {
    if (changeRate < 0) {
      status = Status.SUCCESS;
    } else if (changeRate > 0) {
      status = Status.ERROR;
    }
  } else {
    if (changeRate < 0) {
      status = Status.ERROR;
    } else if (changeRate > 0) {
      status = Status.SUCCESS;
    }
  }

  return status;
};
